import { ValidatorReport } from './ValidatorReport';
import type { TacticalPlanContext } from './TacticalPlanContext';
import { _ } from 'svelte-i18n';
import { ZoneListErrorTypes } from '../Zones/ZoneListTypes';

export class TacticalPlanValidator {
    public testAll(report: ValidatorReport, context: TacticalPlanContext): void {
        // this.checkPriorityUnique(report, context);
        // this.checkPriorityMinusOneExists(report, context);
        // this.checkIfEveryActionOfTypeVehicleHasAssignedVehicle(report, context);
        // this.checkIfVehiclesInZonesAreAssigned(report,context);

        // this.checkIfEveryActionOfTypeMapHasAssignedMap(report, context);
        // this.checkIfEveryDefaultRuleHasSelectedAnyFilter(report, context);
        // this.checkIfVehiclesAreUnique(report, context);
        // this.checkIfVehiclesInZonesAreUnique(report,context);

        // this.checkWholeTacticalPlanForDuplicatedVehicles(report,context);

        this.addWarningIfRuleCanBeGreedy(report, context);
        this.getErrorsFromRulesDetails(report, context);
    }

    public addWarningIfRuleCanBeGreedy(
        report: ValidatorReport,
        context: TacticalPlanContext
    ): void {
        let { tp, tprules, zones } = context.getContext();
        let warningAdded = false;

        tprules.forEach(rule => {
            if (rule.isAlwaysLast()) {
                return;
            }
            if (rule.getMapId() === null) {
                return;
            }
            if (
                rule.hasEmptyFilter() &&
                rule.getRule().details.vehicle_id !== null &&
                !warningAdded
            ) {
                report.addWarning(
                    rule.getRule().id,
                    'this_rule_may_catch_all_deliveries_bcs_of_empty_filter'
                );
                warningAdded = true;
            }
            if (
                !rule.hasEmptyFilter() &&
                rule.getRule().details.vehicle_id !== null &&
                !warningAdded
            ) {
                report.addWarning(rule.getRule().id, 'this_rule_may_catch_all_deliveries');
                warningAdded = true;
            }
        });
    }

    public checkPriorityUnique(report: ValidatorReport, context: TacticalPlanContext): void {
        let { tp, tprules, zones } = context.getContext();
        let priorities = tprules.map(rule => rule.getRule().priority);
        let unique = new Set(priorities);
        if (unique.size !== priorities.length) {
            report.addError(null, 'Priority must be unique', priorities);
        }
    }

    public checkPriorityMinusOneExists(
        report: ValidatorReport,
        context: TacticalPlanContext
    ): void {
        let { tp, tprules, zones } = context.getContext();
        if (!tprules.find(rule => rule.getRule().priority === -1)) {
            report.addError(null, 'Priority -1 must exist');
        }
    }

    public checkIfEveryActionOfTypeVehicleHasAssignedVehicle(
        report: ValidatorReport,
        context: TacticalPlanContext
    ): void {
        let { tp, tprules, zones } = context.getContext();
        tprules.forEach(rule => {
            if (
                rule.getRule().details.action.type === 'vehicle' &&
                rule.getRule().details.action.vehicle_id === null
            ) {
                report.addError(rule.getRule().id, 'please_assign_vehicle');
            }
        });
    }

    public checkIfEveryActionOfTypeMapHasAssignedMap(
        report: ValidatorReport,
        context: TacticalPlanContext
    ): void {
        let { tp, tprules, zones } = context.getContext();
        tprules.forEach(rule => {
            if (
                rule.getRule().details.action.type === 'map' &&
                rule.getRule().details.action.map_id === null &&
                rule.getVehicleId() === null
            ) {
                report.addError(rule.getRule().id, 'please_assign_zones');
            }
        });
    }

    public checkIfEveryDefaultRuleHasSelectedAnyFilter(
        report: ValidatorReport,
        context: TacticalPlanContext
    ): void {
        let { tp, tprules, zones } = context.getContext();
        tprules.forEach(rule => {
            if (!rule.isAlwaysLast() && rule.hasEmptyFilter()) {
                report.addWarning(rule.getRule().id, 'please_set_any_filter');
            }
        });
    }

    public checkIfVehiclesAreUnique(report: ValidatorReport, context: TacticalPlanContext): void {
        let { tp, tprules, zones } = context.getContext();
        let vehicles = tprules
            .filter(rule => rule.getRule().details.action.type === 'vehicle')
            .map(rule => rule.getRule().details.action.vehicle_id);
        let unique = new Set(vehicles);
        if (unique.size !== vehicles.length) {
            report.addWarning(null, 'vehicles_must_be_unique', vehicles);
        }

        tprules.forEach(rule => {
            if (
                rule.getRule().details.action.type === 'vehicle' &&
                rule.getRule().details.action.vehicle_id !== null
            ) {
                let vehicle = tprules.find(
                    r =>
                        r.getRule().details.action.type === 'vehicle' &&
                        r.getRule().details.action.vehicle_id ===
                            rule.getRule().details.action.vehicle_id &&
                        r.getRule().id !== rule.getRule().id
                );
                if (vehicle && vehicle.getRule().id !== rule.getRule().id) {
                    report.addWarning(rule.getRule().id, 'vehicle_must_be_unique');
                }
            }
        });
    }

    public checkIfVehiclesInZonesAreUnique(
        report: ValidatorReport,
        context: TacticalPlanContext
    ): void {
        let { tp, tprules, zones } = context.getContext();
        // [{"map_id":941,"vehicle_id":193,"id":595}]
        let vehicles = zones.filter(zone => zone.vehicle_id !== null).map(zone => zone.vehicle_id);
        let unique = new Set(vehicles);
        if (unique.size !== vehicles.length) {
            report.addWarning(null, 'vehicles_in_zones_must_be_unique', vehicles);
        }
    }

    public checkIfVehiclesInZonesAreAssigned(
        report: ValidatorReport,
        context: TacticalPlanContext
    ): void {
        let { tp, tprules, zones } = context.getContext();
        tprules.forEach(rule => {
            if (
                rule.getRule().details.action.type === 'map' &&
                rule.getRule().details.action.map_id !== null
            ) {
                let zonesInRules = zones.filter(
                    zone => zone.map_id === rule.getRule().details.action.map_id
                );
                let zonesIdInRulesWithVehicleNull = zonesInRules
                    .filter(zone => zone.vehicle_id === null)
                    .map(zone => zone.id);
                if (zonesIdInRulesWithVehicleNull.length > 0) {
                    report.addError(
                        rule.getRule().id,
                        'vehicles_in_zones_must_be_assigned',
                        zonesIdInRulesWithVehicleNull
                    );
                }
            }
        });
    }

    public checkWholeTacticalPlanForDuplicatedVehicles(
        report: ValidatorReport,
        context: TacticalPlanContext
    ): void {
        let { tp, tprules, zones } = context.getContext();
        let vehiclesInAllRules = zones
            .filter(zone => zone.vehicle_id !== null)
            .map(zone => zone.vehicle_id);
        vehiclesInAllRules = [
            ...vehiclesInAllRules,
            ...tprules
                .filter(rule => rule.getRule().details.action.type === 'vehicle')
                .map(rule => rule.getRule().details.action.vehicle_id),
        ];
        let unique = new Set(vehiclesInAllRules);
        if (unique.size !== vehiclesInAllRules.length) {
            tprules.forEach(rule1 => {
                let vehiclesInThisRule: number[] = [];
                if (rule1.getRule().details.action.type === 'map') {
                    vehiclesInThisRule = zones
                        .filter(
                            zone =>
                                zone.map_id === rule1.getRule().details.action.map_id &&
                                zone.vehicle_id !== null
                        )
                        .map(zone => zone.vehicle_id)
                        .filter(v_id => typeof v_id === 'number');
                }
                if (
                    rule1.getRule().details.action.type === 'vehicle' &&
                    rule1.getRule().details.action.vehicle_id !== null
                ) {
                    vehiclesInThisRule = [rule1.getRule().details.action.vehicle_id];
                }

                let vehiclesDuplicated: number[] = [];
                vehiclesInThisRule.forEach(vehicleId => {
                    if (vehiclesInAllRules.filter(v => v === vehicleId).length > 1) {
                        vehiclesDuplicated.push(vehicleId);
                    }
                });
                if (vehiclesDuplicated.length > 0) {
                    report.addError(
                        rule1.getRule().id,
                        'vehicles_in_rule_must_be_unique_in_tactical_plan',
                        vehiclesDuplicated
                    );
                }
            });
            report.addError(null, 'vehicles_must_be_unique_in_tactical_plan', null);
        }
    }

    public getErrorsFromRulesDetails(report: ValidatorReport, context: TacticalPlanContext): void {
        let { tp, tprules, zones } = context.getContext();
        tprules.forEach(rule => {
            if (rule.getErrors().length > 0) {
                rule.getErrors().forEach(error => {
                    report.addError(rule.getId(), error.description, error.details ?? null, error.zoneId, error.uniqueId, error.timestamp);
                });
            }
        });
    }
}
